import validator from "validator";



validator.legalTz = (num)=> {
    var tot  = 0;
    var tz = new String(num);
    for (let i=0; i<8; i++)
    {
       let x = (((i%2)+1)*tz.charAt(i));
        if (x > 9)
        {
            x =x.toString();
            x=parseInt(x.charAt(0))+parseInt(x.charAt(1))
        }
        tot += x;
    }

    if ((tot+parseInt(tz.charAt(8)))%10 == 0) {
        return true;
    } else {
        return false;
    }
}



  export default  validator;
